var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { serverTimestamp as fsServerTimestamp } from 'firebase/firestore';
export var firestoredData = function (_a) {
    var data = _a.data, uid = _a.uid, serverTimestamp = _a.serverTimestamp, isInitial = _a.isInitial;
    var timestamp = serverTimestamp || fsServerTimestamp();
    return __assign(__assign(__assign(__assign(__assign(__assign({}, data), { uid: uid }), (isInitial ? { createdAt: timestamp } : {})), { updatedAt: timestamp }), (isInitial ? { crossrefUpdatedAt: timestamp } : {})), (isInitial ? { pubmedUpdatedAt: timestamp } : {}));
};
